import Committee from "~/typings/committee";

export default function useCommittees(committeesList: Ref<Committee[]|null>) {
  return {
    committees: computed(() => committeesList.value?.filter(c => c.type === 'commissie') || []),
    clubs: computed(() => committeesList.value?.filter(c => c.type === 'club') || [])
  }
}
